import React from 'react';
import { Link } from 'react-router-dom';
import { SourceAvatar, fmtNum, timeAgo } from '../ui';
import './SourceCard.css';

// Картка джерела-конкурента: скільки товарів, яка частка з ціною, коли
// оновлено. Спільна для «Огляду» і сторінки «Конкуренти».
const SourceCard = ({ source: s, index }) => {
    const pct = s.total ? Math.round(s.with_price / s.total * 100) : 0;
    return (
        <Link to={`/competitors/${s.source_key}`} className="ui-card source-card">
            <div className="source-card-top">
                <span className="source-card-name">
                    <SourceAvatar sourceKey={s.source_key} title={s.title} index={index} />
                    <span className="ellipsis">{s.title}</span>
                </span>
                {s.recent_changes > 0 && (
                    <span className="ui-chip ui-chip--accent" title="Змін цін за останню добу">+{fmtNum(s.recent_changes)}</span>
                )}
            </div>
            <div>
                <div className="source-card-num num">{fmtNum(s.total)}</div>
                <div className="muted" style={{ fontSize: 13, marginTop: 4 }}>товарів у базі</div>
            </div>
            <div>
                <div className="ui-progress" style={{ height: 6 }}>
                    <div style={{ width: `${pct}%`, background: 'var(--good)' }} />
                </div>
                <div className="source-card-stock">
                    <span style={{ color: 'var(--good)', fontWeight: 600 }}>{fmtNum(s.with_price)} з ціною</span>
                    <span className="muted num">{pct}%</span>
                </div>
            </div>
            <div className="source-card-time">
                <span className="ui-live-dot" style={{ width: 6, height: 6 }} />
                {s.last_updated ? `оновлено ${timeAgo(s.last_updated)}` : 'ще не збирали'}
            </div>
        </Link>
    );
};

export const SourceGrid = ({ children }) => <div className="source-grid">{children}</div>;

export default SourceCard;
